// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"f1de5fe0","583":"53792d9c"}[chunkId] + ".chunk.js";
};